import { render, staticRenderFns } from "./PlatformUsers.vue?vue&type=template&id=18a20180&scoped=true"
import script from "./PlatformUsers.vue?vue&type=script&lang=js"
export * from "./PlatformUsers.vue?vue&type=script&lang=js"
import style0 from "./PlatformUsers.vue?vue&type=style&index=0&id=18a20180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a20180",
  null
  
)

export default component.exports